const SkillCard = ({ skill, isVisible }) => {
  return (
    <div className={`font-semibold whitespace-nowrap px-4 py-1 rounded-lg text-black bg-zinc-100 transition duration-300 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>
      {skill}
    </div>
  );
};

export default SkillCard;
